import { atom } from 'recoil';

const lang = atom({
  key: 'lang',
  default: 'vi',
});

export default { lang };
